import React, { Component } from 'react';
import ReactGA from 'react-ga';
import '../styles/project.css';
import Projects from '../components/projects';
import { Redirect } from 'react-router-dom';

// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
const keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

class Project extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      modalImg: '',
      modalImgPrev: '',
      modalImgNext: '',
      index: 0,
      prevIndex: 0,
      nextIndex: 0,
      width: 0,
      height: 0,
      orientation: '',
      prevOrientation: '',
      nextOrientation: '',
      x0: null,
      x1: null,
      swipe: '',
    };
    this.closeModal = this.closeModal.bind(this);
    this.showModal = this.showModal.bind(this);
    this.showPrevModal = this.showPrevModal.bind(this);
    this.showNextModal = this.showNextModal.bind(this);
    this.changeModal = this.changeModal.bind(this);
    this.preventDefault = this.preventDefault.bind(this);
    this.preventDefaultForScrollKeys = this.preventDefaultForScrollKeys.bind(
      this
    );
    this.enableScroll = this.enableScroll.bind(this);
    this.disableScroll = this.disableScroll.bind(this);
    this.getLastRef = this.getLastRef.bind(this);
    this.getPrevRef = this.getPrevRef.bind(this);
    this.getNextRef = this.getNextRef.bind(this);
    this.moveTouch = this.moveTouch.bind(this);
    this.lockTouch = this.lockTouch.bind(this);
  }

  preventDefault(e) {
    e = e || window.event;
    e.returnValue = false;
  }

  preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      this.preventDefault(e);
      return false;
    }
  }

  disableScroll() {
    if (window.addEventListener) {
      window.addEventListener('DOMMouseScroll', this.preventDefault, false);
    }
    window.onwheel = this.preventDefault;
    window.onmousewheel = document.onmousewheel = this.preventDefault;
    window.ontouchmove = this.preventDefault;
    document.onkeydown = this.preventDefaultForScrollKeys;
  }

  enableScroll() {
    if (window.removeEventListener) {
      window.removeEventListener('DOMMouseScroll', this.preventDefault, false);
    }
    window.onmousewheel = document.onmousewheel = null;
    window.onwheel = null;
    window.ontouchmove = null;
    document.onkeydown = null;
  }

  componentWillMount() {
    window.scrollTop = window.windowHeight;
    this.enableScroll();
    this.setState({ showModal: false });
  }

  componentDidMount() {
    document.addEventListener('keyup', this.changeModal, { passive: false });
    document.addEventListener('touchstart', this.changeModal, {
      passive: false,
    });
    document.addEventListener('touchend', this.changeModal, { passive: false });
  }

  componentWillUnmount() {
    this.enableScroll();
    this.setState({ showModal: false });
    document.removeEventListener('keyup', this.changeModal, { passive: false });
    document.removeEventListener('touchstart', this.changeModal, {
      passive: false,
    });
    document.removeEventListener('touchend', this.changeModal, {
      passive: false,
    });
  }

  renderGallery(proj) {
    const projImgs = {};
    const gallery = proj.content.map((contentImg, index) => {
      projImgs[index] = contentImg.img;
      return (
        <div
          key={index}
          className={`galleryImage ${contentImg.orientation}`}
          ref={index}
          style={{ backgroundImage: `url(${contentImg.img})` }}
          onClick={this.showModal}
        />
      );
    });
    this.props = { ...this.props, projImgs };
    return gallery;
  }

  showModal(e) {
    for (let ref in this.refs) {
      if (e.target === this.refs[ref]) {
        this.disableScroll();
        const prevRef = this.getPrevRef(e);
        const nextRef = this.getNextRef(e);
        const orientation = this.refs[ref].classList[1];
        const prevOrientation = this.refs[prevRef].classList[1];
        const nextOrientation = this.refs[nextRef].classList[1];
        this.setState({
          showModal: true,
          index: ref,
          prevIndex: prevRef,
          nextIndex: nextRef,
          orientation,
          prevOrientation,
          nextOrientation,
        });
        this.showPrevModal();
        this.showNextModal();
      }
    }
    const modalImg = this.props.projImgs[this.state.index];
    const modalName = modalImg.slice(
      modalImg.lastIndexOf('/') + 1,
      modalImg.indexOf('.')
    );
    ReactGA.event({
      category: 'Modal',
      action: 'show modal',
      label: `show ${modalName} modal`,
    });
    return modalImg;
  }

  showPrevModal() {
    const modalImg = this.props.projImgs[this.state.prevIndex];
    return modalImg;
  }

  showNextModal() {
    const modalImg = this.props.projImgs[this.state.nextIndex];
    return modalImg;
  }

  closeModal() {
    this.enableScroll();
    return this.setState({ showModal: false, modalImg: '' });
  }

  getLastRef() {
    let lastRef = 0;
    for (let ref in this.refs) {
      if (parseInt(ref, 10) > parseInt(lastRef, 10)) {
        lastRef = parseInt(ref, 10);
      }
    }
    return lastRef;
  }

  getPrevRef(e) {
    const lastRef = this.getLastRef();
    for (let ref in this.refs) {
      if (e.target === this.refs[ref]) {
        if (parseInt(ref, 10) === 0) {
          return lastRef;
        }
        return parseInt(ref, 10) - 1;
      }
    }
  }

  getNextRef(e) {
    const lastRef = this.getLastRef();
    for (let ref in this.refs) {
      if (e.target === this.refs[ref]) {
        if (parseInt(ref, 10) === lastRef) {
          return 0;
        }
        return parseInt(ref, 10) + 1;
      }
    }
  }

  lockTouch(e) {
    this.setState({ x0: e.clientX });
  }

  moveTouch(e) {
    this.setState({ x1: e.clientX });
    const minSwipe = window.screen.availWidth / 4;
    if (this.state.x1 > this.state.x0 + minSwipe) {
      this.setState({ swipe: 'right' }, () => {
        setTimeout(() => {
          this.changeModal({ key: 'a' });
        }, 200);
      });
    }
    if (this.state.x1 < this.state.x0 - minSwipe) {
      this.setState({ swipe: 'left' }, () => {
        setTimeout(() => {
          this.changeModal({ key: 'd' });
        }, 200);
      });
    }
  }

  changeModal(e) {
    // Here add a reference to the key pressed and then to the direction
    // Set state to update the index and it should re-render the new modal
    if (this.state.showModal === true) {
      let currentImg = document.querySelector('.modalImage').src;
      currentImg = currentImg.slice(
        currentImg.lastIndexOf('/'),
        currentImg.lastIndexOf('.')
      );
      const lastRef = this.getLastRef();
      let prevOrientation;
      let orientation;
      let nextOrientation;
      for (let ref in this.refs) {
        let refImg = this.refs[ref].style.backgroundImage;
        refImg = refImg.slice(refImg.lastIndexOf('/'), refImg.lastIndexOf('.'));
        if (currentImg === refImg) {
          switch (e.key) {
            case 'Escape':
              this.closeModal();
              break;
            case 'a':
            case 'w':
            case 'ArrowLeft':
            case 'ArrowUp':
              let index = this.state.index;
              let prevIndex = parseInt(this.state.index, 10) - 1;
              let prevPrev = parseInt(this.state.index, 10) - 2;
              if (!this.refs[prevPrev]) {
                prevPrev = lastRef;
              }
              if (!this.refs[prevIndex]) {
                prevIndex = lastRef;
                prevPrev = lastRef - 1;
              }
              nextOrientation = this.state.orientation;
              orientation = this.refs[prevIndex].classList[1];
              prevOrientation = this.refs[prevPrev].classList[1];
              this.setState({
                index: prevIndex,
                prevIndex: prevPrev,
                nextIndex: index,
                orientation,
                prevOrientation,
                nextOrientation,
                swipe: '',
              });
              break;
            case 'd':
            case 's':
            case 'ArrowRight':
            case 'ArrowDown':
              index = this.state.index;
              let nextIndex = parseInt(this.state.index, 10) + 1;
              let nextNext = parseInt(this.state.index, 10) + 2;
              if (!this.refs[nextNext]) {
                nextNext = 0;
              }
              if (!this.refs[nextIndex]) {
                nextIndex = 0;
                nextNext = 1;
              }
              prevOrientation = this.state.orientation;
              orientation = this.refs[nextIndex].classList[1];
              nextOrientation = this.refs[nextNext].classList[1];
              this.setState({
                index: nextIndex,
                nextIndex: nextNext,
                prevIndex: index,
                orientation,
                prevOrientation,
                nextOrientation,
                swipe: '',
              });
              break;
            default:
              break;
          }
          if (e.type === 'touchstart') {
            this.lockTouch(e.changedTouches[0]);
          } else if (e.type === 'touchend') {
            this.moveTouch(e.changedTouches[0]);
          }
        }
      }
    }
  }

  render() {
    const { project } = this.props.match.params;

    let openProjects = Projects.filter(proj => {
      return proj.name === project;
    });
    const proj = openProjects[0];
    if (proj === undefined) {
      return <Redirect to="/missingProject" />;
    }
    return (
      <div className="projectContainer">
        <div
          className="projectBanner"
          style={{ backgroundImage: `url(${proj.banner})` }}
        >
          <div className="bannerOverlay">
            <h1>{proj.title}</h1>
          </div>
        </div>
        <div className="galleryContent">{this.renderGallery(proj)}</div>
        <div
          className={
            this.state.showModal
              ? `modalOverlay prev ${this.state.swipe}`
              : 'hidden'
          }
        >
          <img
            className={
              this.state.showModal
                ? `modalImage ${this.state.prevOrientation} prev`
                : 'hidden'
            }
            src={this.state.showModal ? this.showPrevModal() : null}
            alt={this.state.modalImgPrev}
          />
        </div>
        <div
          className={
            this.state.showModal ? `modalOverlay ${this.state.swipe}` : 'hidden'
          }
          onClick={this.state.showModal ? this.closeModal : null}
        >
          <img
            className={
              this.state.showModal
                ? `modalImage ${this.state.orientation}`
                : 'hidden'
            }
            src={this.state.showModal ? this.showModal(this) : null}
            alt={this.state.modalImg}
          />
        </div>
        <div
          className={
            this.state.showModal
              ? `modalOverlay next ${this.state.swipe}`
              : 'hidden'
          }
        >
          <img
            className={
              this.state.showModal
                ? `modalImage ${this.state.nextOrientation} next`
                : 'hidden'
            }
            src={this.state.showModal ? this.showNextModal() : null}
            alt={this.state.modalImgNext}
          />
        </div>
      </div>
    );
  }
}

export default Project;



// WEBPACK FOOTER //
// ./src/containers/project.js